import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import {AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import {TimeTrackerService} from '../time-tracker-service.service';
import {Subscription} from 'rxjs/Subscription';
import {BsModalService} from 'ngx-bootstrap';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Team} from '../../models/team';
import {TemplateModalComponent} from '../modals/template-modal';
import {Schedule} from '../../models/Schedule';
import {User} from '../../models/User';
import {Device} from '../../models/device';
import {ScheduleModalComponent} from '../modals/schedule-modal';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material';
import {ScheduleService} from '../services/ScheduleService';
import {UserProfileModalComponent} from '../modals/userprofile-modal';
import {Company} from '../../models/company';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit, OnDestroy {

    PHONE = Device.PHONE;
    TABLET = Device.TABLET;

    userSubscription: Subscription;
    user: Observable<firebase.User>;
    teams: AngularFireList<any>;
    userInfo: User = new User();
    listTeams: Array<any> = [];
    listUsersForTeam: User[];
    bsModalRef: BsModalRef;
    companyId: string;

    currentTeamSelected: Team;

    subCompanyGroups: Array<Company> = [];

    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase,
                public tts: TimeTrackerService, public scheduleService: ScheduleService,
                public ts: TranslateService, public snackBar: MatSnackBar,
                public bsModalService: BsModalService) {

        this.user = this.afAuth.authState;
    }

    ngOnInit() {
        console.log('Dashboard: ngOnInit()');
        this.userSubscription = this.user.subscribe(userInfo => {
            this.userSubscription.unsubscribe();
            if (userInfo) {
                this.tts.getUserFromId(userInfo.uid, userProfile => {
                    if (userProfile.payload.val()) {
                        this.userInfo = userProfile.payload.val();
                        if (!this.userInfo.isAdmin) {
                            this.afAuth.auth.signOut();
                        }

                        this.loadChildCompanies();

                        // Load rootCompany users and teams
                        this.companyId = userProfile.payload.val().companyId;
                        this.getUnassignedUsers(this.companyId);
                        this.showAllUsers();
                        this.tts.getTeamsFromCompany(this.companyId, teams => {
                            this.listTeams = teams;
                        });
                    } else {
                        this.ts.get('DASHBOARD.CANT_LOAD_INFO').subscribe(str => {
                            this.snackBar.open(str, null, {duration: 2000});
                        });
                    }
                });
            }
        });
    }

    public showAllUsers() {
        this.currentTeamSelected = null;
        this.loadUsersByQueryList(this.af.list<User>(TimeTrackerService.USERS,
            query => query.orderByChild('companyId').equalTo(this.companyId)));
    }

    private loadUsersByQueryList(list: AngularFireList<User>) {
        list.valueChanges()
            .subscribe(listUsers => {
                for (let ind = 0; ind < listUsers.length; ind++) {
                    const user = listUsers[ind];
                    user.device = this.af.list<Device>(TimeTrackerService.USER_DEVICES,
                        query => query.orderByChild('userId').equalTo(user.id))
                        .valueChanges();
                    user.schedule = this.af.list<Schedule>(TimeTrackerService.SCHEDULES,
                        query => query.orderByChild('userId').equalTo(user.id))
                        .valueChanges();
                }

                this.listUsersForTeam = listUsers;
            });
    }

    public showTeamUsers(team: Team) {
        this.currentTeamSelected = team;
        this.loadUsersByQueryList(this.af.list<User>(TimeTrackerService.USERS, query => query.orderByChild('teamId').equalTo(team.id)));
    }

    public getUnassignedUsers(companyId: string) {
        /* this.af.list<User>(TimeTrackerService.USERS,
             query => query.orderByChild('companyId').equalTo(companyId))
             .valueChanges()
             .subscribe(listUsers => {
                 console.log('listUsers', listUsers, listUsers[0]);

                 for (let ind = 0; ind < listUsers.length; ind++) {
                     const user = listUsers[ind];

                     if (user.teamId) {
                         listUsers.splice(ind, 1);
                         ind--;
                     } else {
                         user.device = this.af.list<Device>(TimeTrackerService.USER_DEVICES,
                             query => query.orderByChild('userId').equalTo(user.id))
                             .valueChanges();
                         user.schedule = this.af.list<Schedule>(TimeTrackerService.SCHEDULES,
                             query => query.orderByChild('userId').equalTo(user.id))
                             .valueChanges();
                     }
                 }
                 this.listUsersForTeam = listUsers;
             }); */
    }

    ngOnDestroy() {
        console.log('unsubscribe user');
    }

    public registerNewUser(companyId: string) {
        this.bsModalRef = this.bsModalService.show(UserProfileModalComponent);
        const mod = User.toModelTemplate(null);
        mod.mode_edit = true;
        mod.config.title = 'MODEL.USER.CREATE_USER';
        this.bsModalRef.content.setUser(null, companyId);
    }

    public assignSchedule(user: User) {
        this.bsModalRef = this.bsModalService.show(ScheduleModalComponent);
        this.bsModalRef.content.user = user;
    }

    public editSchedule(user: User, schedule: Schedule) {
        console.log(schedule);
        this.bsModalRef = this.bsModalService.show(ScheduleModalComponent);
        this.bsModalRef.content.user = user;
        this.bsModalRef.content.schedule = Object.assign({}, schedule);
        this.bsModalRef.content.editMode = true;
    }

    public editDevice(device: Device) {
        console.log('edit device: ', device);
        this.bsModalRef = this.bsModalService.show(TemplateModalComponent);
        const mod = Device.toModelTemplate(device);
        mod.mode_edit = true;
        mod.mode_delete = true;
        mod.config.title = 'MODEL.DEVICE.EDIT_DEVICE';
        this.bsModalRef.content.model = mod;
    }

    public addNewDevice(user: User) {
        console.log('new device: ');
        this.bsModalRef = this.bsModalService.show(TemplateModalComponent);
        const mod = Device.toModelTemplate(null);
        mod.setValue('userId', user.id);
        mod.setValue('name', this.PHONE);
        mod.mode_create = true;
        mod.config.title = 'MODEL.DEVICE.CREATE_DEVICE';
        this.bsModalRef.content.model = mod;
    }

    public editUser(user: User) {
        console.log('edit user: ', user);
        this.bsModalRef = this.bsModalService.show(UserProfileModalComponent);
        const mod = User.toModelTemplate(user);
        mod.mode_edit = true;
        mod.config.title = 'MODEL.USER.EDIT_USER';
        this.bsModalRef.content.setUser(user, this.companyId);
    }

    public addNewTeam() {
        this.bsModalRef = this.bsModalService.show(TemplateModalComponent);
        const mod = Team.toModelTemplate(this.companyId, null);
        mod.mode_create = true;
        mod.config.title = 'MODEL.TEAM.CREATE_TEAM';
        this.bsModalRef.content.model = mod;
    }

    public editTeam(team: Team) {
        this.bsModalRef = this.bsModalService.show(TemplateModalComponent);
        const mod = Team.toModelTemplate(this.companyId, team);
        mod.mode_edit = true;
        mod.mode_delete = false;
        mod.config.title = 'MODEL.TEAM.EDIT_TEAM';
        this.bsModalRef.content.model = mod;
    }

    public loadChildCompanies() {
        this.subCompanyGroups = [];
        this.tts.getCompanyFromId(this.userInfo.companyId, rootCompany => {
            this.subCompanyGroups.push(rootCompany);
            this.tts.getChildGroups(rootCompany.id, data => {
                this.subCompanyGroups = this.subCompanyGroups.concat(data);
            });
        });
    }

    public loadDataFromCompany() {
        console.log('Selected Company: ' + this.companyId);
        this.getUnassignedUsers(this.companyId);
        this.showAllUsers();
        this.tts.getTeamsFromCompany(this.companyId, teams => {
            this.listTeams = teams;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts